const config = {
  apiUrl: "https://kotirinne.qtie.fi/",
};

export default config;
